import { createPortal } from 'react-dom';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';

function withTab(path, tab) {
  const url = new URL(path, window.location.origin);
  url.searchParams.set('tab', tab);

  return `${url.pathname}${url.search}`;
}

export default function ReportBreadCrumbs({ baseReportName, reportsPath, savedReport }) {
  const anchorProps = {};
  let label = baseReportName;
  if (savedReport?.name) {
    // The reports list shows a view someone else shared under Shared with me, not under My reports.
    anchorProps.href = savedReport.owned ? reportsPath : withTab(reportsPath, 'shared');
    label = savedReport.owned ? 'My Reports' : 'Shared with me';
  }

  return (
    createPortal(
      <React.Fragment>
        <a className="ds-text-secondary" {...anchorProps} >
          {label}
        </a>
        {savedReport?.name ? (
          <React.Fragment>
            <FontAwesomeIcon icon={faChevronRight} size="sm"/>
            {savedReport.name}
          </React.Fragment>
        ) : null}
      </React.Fragment>,
      document.getElementById('saved-report-portal')
    )
  );
}

ReportBreadCrumbs.propTypes = {
  baseReportName: PropTypes.string.isRequired,
  reportsPath: PropTypes.string.isRequired,
  savedReport: PropTypes.object,
};
